import React, { useCallback, memo } from 'react';
import classname from 'classnames';
import { Cell } from 'zarm';
import { template } from '@iyunbao/cr-engine';

import { ActionProps, BaseWidgetProps } from '../utils/type';

export interface CellProps extends BaseWidgetProps {
  label?: string;
  subTitle?: string;
  more: {
    label?: string;
    action?: ActionProps;
    log?: string;
  };
  hasArrow?: boolean;
  help?: string;
  icon?: string;
  className?: string;
  description?: string;
  style?: React.CSSProperties;
}

const UCell = (props: CellProps) => {
  const {
    prefixCls = 'crm-cell',
    label,
    subTitle,
    more = {},
    className,
    style,
    hasArrow = false,
    help,
    description,
    _crengine,
    onLog,
  } = props;

  const cls = classname(prefixCls, className);

  function renderTitle(title: any, subtitle: any) {
    if (!subtitle) return title;

    return (
      <>
        {title}<span className={`${prefixCls}-subtitle`}>{subtitle}</span>
      </>
    );
  }

  const renderDesc = useCallback(() => {
    const { log, action } = more;

    const moreLabel = description || more.label;

    if (!moreLabel) return null;

    const { action: waction } = _crengine || {};

    return (
      <div
        onClick={() => {
          if (log && onLog) {
            onLog && onLog(log);
          }

          if (waction && action) {
            waction(action);
          }
        }}
      >
        {template(moreLabel)}
      </div>
    );
  }, [more, description, _crengine]);

  return (
    <Cell
      title={renderTitle(label, subTitle)}
      description={renderDesc()}
      hasArrow={hasArrow}
      help={help}
      className={cls}
      style={style}
    />
  );
};

export default memo(UCell);
